module.exports = __webpack_public_path__ + "static/media/lollipop.5bf858ee.svg";